// Customer type options by CountryCode
export var CustomerTypeConfigurationsV2 = function(countryCode, USER_TYPE, strings) {
    /* Public Functions */

    var getCustomerTypeConfigurations = function(countryCode) {
        if ((countryCode.toLowerCase() + 'CustomerTypeConfigurations') in configurationCollection) {
            return new configurationCollection[countryCode.toLowerCase() + 'CustomerTypeConfigurations']();
        } else {
            return new configurationCollection.baseCustomerTypeConfigurations();
        }
    };

    /* Private Variables */

    // market-specific configurations
    var configurationCollection = {};

    /* Private Functions */

    // helper for setting up inheritance
    var inheritsFrom = function(child, parent) {
        child.prototype = Object.create(parent.prototype);
    };

    /* CustomerTypeConfigurations */

    // base configuration stubs each property setter
    var BaseCustomerTypeConfigurations = function() {};
    BaseCustomerTypeConfigurations.prototype.getCustomer = function() {};
    BaseCustomerTypeConfigurations.prototype.getMember = function() {};
    BaseCustomerTypeConfigurations.prototype.getCustomerTypes = function() {};
    BaseCustomerTypeConfigurations.prototype.matchCustomerTypes = function() {};
    configurationCollection.baseCustomerTypeConfigurations = BaseCustomerTypeConfigurations;

    // Default configuration overrides a subset of the property setters with behavior common across Default markets
    var DefaultCustomerTypeConfigurations = function() {};
    inheritsFrom(DefaultCustomerTypeConfigurations, BaseCustomerTypeConfigurations);
    DefaultCustomerTypeConfigurations.prototype.getCustomer = function() {
        var retailCustomer = {
            type: USER_TYPE.RETAIL_CUSTOMER,
            label: strings.get('tdc_customerButton'),
            description: strings.get('tdc_customerDescription'),
            queryParameter: USER_TYPE.RETAIL_CUSTOMER
        };
        return retailCustomer;
    };
    DefaultCustomerTypeConfigurations.prototype.getMember = function() {
        var preferredCustomer = {
            type: USER_TYPE.PREFERRED_CUSTOMER,
            label: strings.get('tdc_memberButton'),
            description: strings.get('tdc_memberDescription'),
            queryParameter: USER_TYPE.PREFERRED_CUSTOMER
        };
        return preferredCustomer;
    };
    DefaultCustomerTypeConfigurations.prototype.getCustomerTypes = function() {
        var customerTypes =[];
        customerTypes.push(DefaultCustomerTypeConfigurations.prototype.getCustomer(),
            DefaultCustomerTypeConfigurations.prototype.getMember());

        return customerTypes;
    };
    DefaultCustomerTypeConfigurations.prototype.matchCustomerTypes = function(matchType) {
        var customerTypes = DefaultCustomerTypeConfigurations.prototype.getCustomerTypes();
        var match = null;
        if (matchType) {
            for (var i=0; i<customerTypes.length; i++) {
                if (matchType === customerTypes[i].type) {
                    match = customerTypes[i];
                }
            }
            return match;
        } else {
            return null;
        }
    };

    // Alternate configuration overrides a subset of the property setters with behavior common across Alternate markets
    var AlternateCustomerTypeConfigurations = function() {};
    inheritsFrom(AlternateCustomerTypeConfigurations, BaseCustomerTypeConfigurations);
    AlternateCustomerTypeConfigurations.prototype.getCustomer = function() {
        var retailCustomer = {
            type: USER_TYPE.RETAIL_CUSTOMER,
            label: strings.get('tdc_customerButton'),
            description: strings.get('tdc_customerDescription'),
            queryParameter: USER_TYPE.RETAIL_CUSTOMER
        };
        return retailCustomer;
    };
    AlternateCustomerTypeConfigurations.prototype.getCustomerTypes = function() {
        var customerTypes =[];
        customerTypes.push(AlternateCustomerTypeConfigurations.prototype.getCustomer());

        return customerTypes;
    };
    AlternateCustomerTypeConfigurations.prototype.matchCustomerTypes = function(matchType) {
        var customerTypes = AlternateCustomerTypeConfigurations.prototype.getCustomerTypes();
        var match = null;
        if (matchType) {
            for (var i=0; i<customerTypes.length; i++) {
                if (matchType === customerTypes[i].type) {
                    match = customerTypes[i];
                }
            }
            return match;
        } else {
            return null;
        }
    };

    // US configuration inherits from Default configuration
    var UsCustomerTypeConfigurations = function() {};
    inheritsFrom(UsCustomerTypeConfigurations, DefaultCustomerTypeConfigurations);
    configurationCollection.usCustomerTypeConfigurations = UsCustomerTypeConfigurations;

    // CA configuration inherits from Default configuration
    var CaCustomerTypeConfigurations = function() {};
    inheritsFrom(CaCustomerTypeConfigurations, DefaultCustomerTypeConfigurations);
    configurationCollection.caCustomerTypeConfigurations = CaCustomerTypeConfigurations;

    // TH configuration inherits from Default configuration
    var ThCustomerTypeConfigurations = function() {};
    inheritsFrom(ThCustomerTypeConfigurations, AlternateCustomerTypeConfigurations);
    configurationCollection.thCustomerTypeConfigurations = ThCustomerTypeConfigurations;

    return {
        getCustomerTypeConfigurations: getCustomerTypeConfigurations
    };
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/customer-types/customer-type-configurationsV2.js
// module id = 348
// module chunks = 0